import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { settings } from ".";

export const definition: WidgetDefinition = {
  id: "cdnsa-indicator",
  module: widgetModule,
  catalog: {
    description: "Up to three distinct observed CDN/SA measurements.",
    domain: "cdnsa",
    visual: "KPI",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpi" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
